<template>
  <div style="padding-top: 1px;">
    <div v-show="hasData" class="play-history">
      <div v-if="!isEdit" class="history-button">
        <span @click="isEdit=true">编辑</span>
      </div>
      <div v-else class="history-button history-button-success">
        <MCheckBox v-model="checkAll" @change="handleCheckAllChange"/>
        <span @click="isEdit=false">完成</span>
      </div>
      <div class="history-container">
        <div :class="['history-scroll', isEdit?'history-scroll-edit':'']">
          <MCheckBoxGroup v-model="selectAlbum" @change="handleCheckChange">
            <div v-if="today.length" class="history-list">
              <div class="history-title">今天</div>
              <div v-for="(item, key) in today" :key="key" class="history-item" @click="clickHandle(item)">
                <div class="history-item-content">
                  <MCheckBox v-if="isEdit" :name="'albumid'" :label="item.albumid" class="history-item-check"/>
                  <img :src="item.img" alt="专辑图片">
                  <div>
                    <div class="history-item-title">{{ item.title }}</div>
                    <div class="history-item-desc">观看至"{{ item.playTitle }}"</div>
                    <div class="history-item-time">
                      <span v-if="item.totalTime">剩余 {{ item.totalTime-item.remainTime | duration }}</span>
                      <span v-else>未观看</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="yeday.length" class="history-list">
              <div class="history-title">昨天</div>
              <div v-for="(item, key) in yeday" :key="key" class="history-item" @click="clickHandle(item)">
                <div class="history-item-content">
                  <MCheckBox v-if="isEdit" :name="'albumid'" :label="item.albumid" class="history-item-check"/>
                  <img :src="item.img" alt="专辑图片">
                  <div>
                    <div class="history-item-title">{{ item.title }}</div>
                    <div class="history-item-desc">观看至"{{ item.playTitle }}"</div>
                    <div class="history-item-time">
                      <span v-if="item.totalTime">剩余 {{ item.totalTime-item.remainTime | duration }}</span>
                      <span v-else>未观看</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="other.length" class="history-list">
              <div class="history-title">更早</div>
              <div v-for="(item, key) in other" :key="key" class="history-item" @click="clickHandle(item)">
                <div class="history-item-content">
                  <MCheckBox v-if="isEdit" :name="'albumid'" :label="item.albumid" class="history-item-check"/>
                  <img :src="item.img" alt="专辑图片">
                  <div>
                    <div class="history-item-title">{{ item.title }}</div>
                    <div class="history-item-desc">观看至"{{ item.playTitle }}"</div>
                    <div class="history-item-time">
                      <span v-if="item.totalTime">剩余 {{ item.totalTime-item.remainTime | duration }}</span>
                      <span v-else>未观看</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </MCheckBoxGroup>
        </div>
      </div>
      <div v-if="isEdit" class="history-all-clear" @click="delHistory">删除</div>
    </div>
    <no-data v-show="!hasData" :remark="'您还没有观影记录，快去观看吧!!!'" />
  </div>
</template>

<script>
import NoData from '@/components/NoData'
import { readHistory, clearHistory, deleteHistory } from './models/storage'
import MCheckBox from '@/components/checklist/CheckBox'
import MCheckBoxGroup from '@/components/checklist/CheckBoxGroup'
export default {
  name: 'PlayHistory',
  components: {
    NoData, MCheckBox, MCheckBoxGroup
  },
  filters: {
    duration(time){
      const second = time%60
      const m = (time-second)/60
      const minut = m%60
      const hour = (m-minut)/60
      return (hour != 0? hour+':':'')+Math.floor(minut)+':'+Math.floor(second)
    }
  },
  data () {
    return {
      isEdit: false,
      today: [],
      yeday: [],
      other: [],
      allData: [],

      checkAll: false,
      selectAlbum: []
    }
  },
  created () {
    this.getAllHistory()
  },
  computed: {
    hasData: function() {
      return this.allData.length>0
    }
  },
  methods: {
    getAllHistory(){
      const history = readHistory()
      if(history){
        this.today = history.today
        this.yeday = history.yeday
        this.other = history.other
        this.allData = history.all
      }else{
        this.today = []
        this.yeday = []
        this.other = []
        this.allData = []
      }
    },
    delHistory() {
      if(this.checkAll){
        clearHistory()
      }else{
        deleteHistory(this.selectAlbum)
      }
      this.getAllHistory()
    },
    clickHandle(item){
      if(this.isEdit){
        return
      }
      this.$router.push({path: '/play', query:{id: item.albumid}})
    },
    handleCheckAllChange(val){
      if(val) {
        this.selectAlbum = this.allData
      }else{
        this.selectAlbum = []
      }
    },
    handleCheckChange(val) {
      if(val.length == this.allData.length){
        this.checkAll = true
      }else{
        this.checkAll = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.play-history{
  height: calc(100vh - 1px);
  text-align: left;
  .history-button{
    text-align: right;
    padding: 10px 16px;
    background-color: #fff;
  }
  .history-button-success{
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .history-container{
    overflow: hidden;
    .history-scroll{
      height: calc(100vh - 54px);
      overflow-y: auto;
      &.history-scroll-edit{
        height: calc(100vh - 99px);
      }
      .history-list{
        background-color: #fff;
        padding-left: 13px;
        margin-bottom: 13px;
        .history-title{
          padding: 10px 0;
        }
      }
    }
  }
  .history-item{
    text-align: left;
    margin-bottom: 16px;
    .history-item-content{
      display: flex;
      align-items: flex-start;
      .history-item-check{
        align-self: center;
        margin-right: 13px;
      }
      img{
        width: 74px;
        height: 74px;
        border-radius: 10px;
        margin-right: 13px;
      }
      &>div:last-child{
        flex: 1;
        border-bottom: solid 1px #EEE;
      }
    }
    .history-item-title{
      color: #333;
    }
    .history-item-desc{
      font-size: 13px;
      color: #999;
      padding: 10px 0;
    }
    .history-item-time{
      font-size: 13px;
      color: #999;
      padding-top: 6px;
      padding-bottom: 10px;
    }
  }
  .history-all-clear{
    text-align: center;
    color: #666;
    padding: 13px 0;
  }
}
</style>
